import React from 'react';
import classNames from 'classnames';
import navButtonImage from './navbar.png';

function NavButton(_ref) {
  var isOpen = _ref.isOpen,
      onClick = _ref.onClick;
  return React.createElement("div", {
    id: "nav-button",
    className: classNames({
      open: isOpen
    }),
    onClick: onClick
  }, React.createElement("span", null, "NAV", React.createElement("img", {
    src: navButtonImage,
    alt: "Navbar"
  })));
}

export default NavButton;